import { defineAsyncComponent } from 'vue';

const auditRouter = [
	/* 合同审批（连续普通点击） */
	{
		path: 'audit/contract',
		component: () => import('@/views_mb/contractAudit/Index.vue'),
		name: 'MbCtAuditSteady',
		meta: { title: '合同审核', hidden: true },
	},
	/* 付款审批（连续普通点击） */
	{
		path: 'audit/bill_pay',
		component: () => import('@/views_mb/bills/BillAudit.vue'),
		name: 'MbPayBillAudit',
		meta: { title: '付款审批', hidden: true },
	},
	/* 付款审批（微信跳转）*/
	{
		path: 'audit/billwork/:workId',
		component: () => import('@/views_mb/bills/BillWorkAudit.vue'),
		name: 'MbBillAudits',
		meta: { title: '付款审批', hidden: true },
	},
];

/* 移动端路由（临时） */
const mobileRouter = {
	path: '/mobile',
	redirect: '/mobile/login',
	name: 'MobileRoot',
	meta: { hidden: true },
	children: [
		...auditRouter,
		{
			path: 'login',
			component: () => import('@/views_mb/MobileLogin.vue'),
			name: 'MobileLogin',
			meta: { hidden: true },
		},
		{
			path: 'contract/detail',
			component: () => import('@/views_mb/contract/Index.vue'),
			name: 'MbCtDetail',
			meta: { hidden: true },
		},
		{
			path: 'contract/create',
			component: () => import('@/views_mb/contractCreate/Index.vue'),
			name: 'MbCtCreate',
			meta: { hidden: true },
		},
		{
			path: 'contract/audit/:workId',
			component: () => import('@/views_mb/contractAudit/IndexWechat.vue'),
			name: 'MbCtAudit',
			meta: { title: '合同审核', hidden: true },
		},
		/* 履约情况 */
		{
			path: 'preforms/list',
			component: () => import('@/views_mb/performs/Index.vue'),
			name: 'MbPerformList',
			meta: { title: '履约合同', hidden: true },
		},
		/* 付款申请 */
		{
			path: 'preforms/payapply',
			component: () => import('@/views_mb/performs/components/Apply.vue'),
			name: 'MbPayApply',
			meta: { title: '付款申请', hidden: true },
		},
		{
			path: 'preforms/detail/:planId',
			component: () => import('@/views_mb/performs/PerformDetail.vue'),
			name: 'MbPerformDetail',
			meta: { title: '应付台账' },
		},
		/* onlyoffice 文档查询 previews */
		{
			path: 'doc',
			component: defineAsyncComponent(() => import('@/views/onlyoffice/Index.vue')),
			name: 'MobileDocRooter',
			meta: { hidden: true },
			children: [
				{
					path: 'previews',
					component: () => import('@/views/onlyoffice/MbPerview.vue'),
					name: 'MobileDocPriview',
					meta: { title: '合同文档预览' },
				},
			],
		},
		{
			path: 'tabs',
			component: () => import('@/layouts/mobile/index.vue'),
			redirect: '/mobile/tabs/welcomes',
			name: 'MobileTabs',
			meta: { hidden: true },
			children: [
				{
					path: 'welcomes',
					component: () => import('@/views_mb/tabs/Welcomes/index.vue'),
					name: 'WelcomesTab',
					meta: { title: '首页', alwaysShow: true },
				},
				{
					path: 'pending',
					component: () => import('@/views_mb/tabs/MbPending.vue'),
					name: 'PendingTab',
					meta: { title: '待办', alwaysShow: true },
				},
				{
					path: 'contracts',
					component: () => import('@/views_mb/tabs/MbContracts.vue'),
					name: 'MbContractTab',
					meta: { title: '合同列表', alwaysShow: true },
				},
				{
					path: 'involved',
					component: () => import('@/views_mb/tabs/MbInvolved.vue'),
					name: 'MbInvolvedTab',
					meta: { title: '历史参与', alwaysShow: true },
				},
				{
					path: 'statistics',
					component: () => import('@/views_mb/tabs/MbStatistics.vue'),
					name: 'StatisticsTab',
					meta: { title: '统计', alwaysShow: true },
				},
			],
		},
	],
};

export { mobileRouter };
